import React, { useState, useRef, useEffect } from 'react';
import { askCDSQuestion } from '../services/api';

function summaryToText(summary) {
  if (!summary) return '';
  return summary.map((s) => `${s.title}: ${(s.items || []).join('; ')}`).join('\n');
}

function diagnosesToText(diagnoses) {
  if (!diagnoses) return '';
  return diagnoses.map((d) => `${d.name}: ${d.reason}`).join('\n');
}

function CDSChat({ transcript, summary, diagnoses, patientContext, onAdopt }) {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages, isLoading]);

  const handleSend = async () => {
    const question = input.trim();
    if (!question || isLoading) return;

    const history = [...messages, { role: 'user', content: question }];
    setMessages(history);
    setInput('');
    setIsLoading(true);

    try {
      const answer = await askCDSQuestion(
        question,
        transcript,
        summaryToText(summary),
        diagnosesToText(diagnoses),
        patientContext,
        history
      );
      setMessages((prev) => [...prev, { role: 'assistant', content: answer }]);
    } catch {
      setMessages((prev) => [
        ...prev,
        { role: 'assistant', content: 'Die Anfrage ist fehlgeschlagen. Bitte erneut versuchen.', isError: true },
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="card cds-chat-card">
      <h2>Rückfragen an die KI</h2>
      <div className="cds-chat-messages" ref={scrollRef}>
        {messages.length === 0 ? (
          <div style={{ color: '#9ca3af', fontSize: '14px' }}>
            Stellen Sie gezielte Fragen zum Fall — z.B. zu Differentialdiagnosen, Leitlinien oder Medikation.
            Antworten lassen sich mit einem Klick in die Ergänzungen übernehmen.
          </div>
        ) : (
          messages.map((m, i) => (
            <div key={i} className={`cds-chat-message ${m.role}`}>
              <div className="cds-chat-bubble">{m.content}</div>
              {m.role === 'assistant' && !m.isError && (
                <button
                  type="button"
                  className="cds-chat-adopt-btn"
                  onClick={() => onAdopt(m.content)}
                >
                  In Ergänzungen übernehmen?
                </button>
              )}
            </div>
          ))
        )}
        {isLoading && (
          <div className="cds-chat-message assistant">
            <div className="cds-chat-bubble">…</div>
          </div>
        )}
      </div>
      <div className="cds-chat-input-row">
        <textarea
          className="cds-chat-input"
          placeholder="Frage an die KI stellen..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <button type="button" className="cds-chat-send-btn" onClick={handleSend} disabled={isLoading || !input.trim()}>
          Senden
        </button>
      </div>
    </div>
  );
}

export default CDSChat;
